import clsx from "clsx";
import { useForm as useFormHook } from "hooks";
import { convertToDateTime } from "util/transformers";
import { UiDateTimeFormatter } from "util/formaters";
// import useValidationSchema from "./useValidationSchema";
import type { HighRiskMerchant } from 'features/ecommerce/types';
import type {
    OnboardingDirectorsAndShareholders,
    OnboardingDirectorsAndShareholdersForm
} from "./types";
import { Identity } from "./entities";

export const getInitialValues = ({
    authSigCountryOrigin = null,
    ceoCountryOrigin = null,
    authSigAddressLine1,
    authSigAddressLine2,
    authSigCity,
    authSigDateOfBirth,
    authSigEmail,
    authSigName,
    authSigPassportExpDate,
    authSigPassportNumber,
    authSigPhone,
    authSigPostalCode,
    authSigTitle,
    ceoAddressLine1,
    ceoAddressLine2,
    ceoCity,
    ceoDateOfBirth,
    ceoEmail,
    ceoName,
    ceoPassportExpDate,
    ceoPassportNumber,
    ceoPhone,
    ceoPostalCode,
    ceoTitle,
    otherPeople = []
}: Partial<HighRiskMerchant.OnboardingDirectorsAndShareholders>): OnboardingDirectorsAndShareholders => ({
    authSigAddressLine1: clsx(authSigAddressLine1),
    authSigAddressLine2: clsx(authSigAddressLine2),
    authSigCity: clsx(authSigCity),
    authSigCountryOrigin,
    authSigDateOfBirth: convertToDateTime(authSigDateOfBirth, UiDateTimeFormatter.Ui),
    authSigEmail: clsx(authSigEmail),
    authSigName: clsx(authSigName),
    authSigPassportExpDate: convertToDateTime(authSigPassportExpDate, UiDateTimeFormatter.Ui),
    authSigPassportNumber: clsx(authSigPassportNumber),
    authSigPhone: clsx(authSigPhone),
    authSigPostalCode: clsx(authSigPostalCode),
    authSigTitle: clsx(authSigTitle),
    ceoAddressLine1: clsx(ceoAddressLine1),
    ceoAddressLine2: clsx(ceoAddressLine2),
    ceoCity: clsx(ceoCity),
    ceoCountryOrigin,
    ceoDateOfBirth: convertToDateTime(ceoDateOfBirth, UiDateTimeFormatter.Ui),
    ceoEmail: clsx(ceoEmail),
    ceoName: clsx(ceoName),
    ceoPassportExpDate: convertToDateTime(ceoPassportExpDate, UiDateTimeFormatter.Ui),
    ceoPassportNumber: clsx(ceoPassportNumber),
    ceoPhone: clsx(ceoPhone),
    ceoPostalCode: clsx(ceoPostalCode),
    ceoTitle: clsx(ceoTitle),
    otherPeople: otherPeople.map(person => new Identity(person))
});

export const useForm = (onboardingDirectorsAndShareholders: OnboardingDirectorsAndShareholdersForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingDirectorsAndShareholders,
        validateOnMount: true,
        // validationSchema: useValidationSchema()
    });
